import { useState, useEffect } from "react";
import { getSettings } from "./settings";

// Dictionnaire de traduction de l'interface (fr / en / ru).
export const translations = {
  fr: {
    app_loading: "un instant…",
    app_auth_error:
      "Connexion impossible. Réessaie dans un instant.",

    login_subtitle: "Entre ton e-mail, on t'envoie un lien pour te connecter.",
    login_email_placeholder: "ton@email.com",
    login_cta: "Recevoir mon lien",
    login_sent: "Vérifie ta boîte mail, on t'a envoyé un lien pour te connecter.",
    login_other_email: "Utiliser une autre adresse",
    login_error: "Envoi impossible. Vérifie ton e-mail et réessaie.",
    login_error_rate: "Trop de demandes. Patiente quelques minutes avant de réessayer.",
    login_error_invalid: "Adresse e-mail invalide. Vérifie et réessaie.",
    login_note: "Pas de mot de passe. Le même lien sert à te connecter et à créer ton compte.",
    login_pwd_link: "Se connecter avec un mot de passe",
    login_pwd_password_placeholder: "Mot de passe",
    login_pwd_cta: "Se connecter",
    login_pwd_error: "E-mail ou mot de passe incorrect.",
    login_pwd_hide: "Utiliser plutôt le lien magique",

    cap_settings_aria: "Réglages",
    cap_placeholder: "Écris, ou maintiens le micro…",
    cap_prompt: "Attrape ce qui te passe par la tête",
    cap_listening: "je t'écoute… glisse ↑ pour verrouiller",
    cap_listening_locked: "je t'écoute, parle librement…",
    cap_transcribing: "je transcris…",
    cap_caught: "attrapé",
    cap_err_mic: "Micro indisponible. Autorise l'accès au micro.",
    cap_err_transcribe: "La transcription a échoué. Réessaie.",
    cap_err_save: "Le souvenir n'a pas pu être enregistré.",
    cap_locked: "Verrouillé",
    cap_hands_free: "mains libres",
    cap_finish: "Terminer",
    cap_send_aria: "Envoyer",
    cap_hold_aria: "Maintenir pour dicter",

    exp_title: "Explorer",
    exp_subtitle: "Ce que tu as attrapé.",
    exp_loading: "Chargement…",
    exp_err_load: "Impossible de charger les souvenirs.",
    exp_empty: "Rien encore. Retourne capturer un souvenir.",
    exp_audio_no_text: "(audio sans texte)",
    exp_err_audio: "Lecture audio impossible.",
    exp_voice_tag: " · 🎙 voix",
    exp_del_title: "Effacer ce souvenir ?",
    exp_del_text: "Le texte ET l'audio seront effacés, définitivement.",
    exp_cancel: "Annuler",
    exp_delete: "Effacer",
    exp_err_delete: "La suppression a échoué.",
    exp_play_aria: "Écouter",
    exp_pause_aria: "Pause",
    exp_delete_aria: "Effacer ce souvenir",

    set_title: "Réglages",
    set_how_title: "Comment ça marche",
    set_privacy_title: "Confidentialité",
    set_back_aria: "Retour",
    set_ui_lang: "Langue de l'interface",
    set_ui_lang_sub: "La langue de l'app.",
    set_input_lang: "Langue de saisie",
    set_input_lang_sub: "Pour capturer tes souvenirs.",
    set_hand: "Main dominante",
    set_hand_sub: "Place « Capturer » sous ton pouce.",
    set_left: "Gaucher",
    set_right: "Droitier",
    set_theme: "Thème",
    set_theme_sub: "L'ambiance de l'app.",
    set_day: "Jour",
    set_night: "Nuit",
    set_system: "Système",
    set_how: "Comment ça marche",
    set_how_sub: "Le geste, en 30 secondes.",
    set_data: "Mes données",
    set_data_sub: "Exporte ou efface tes souvenirs.",
    set_export: "Exporter (JSON)",
    set_delete_data: "Supprimer mes données",
    set_delete_all_text: "Ça effacera tous tes souvenirs, définitivement. Continuer ?",
    set_delete_yes: "Oui, effacer",
    set_exported: "{n} souvenir(s) exporté(s).",
    set_err_export: "L'export a échoué.",
    set_deleted_all: "Tes souvenirs ont été supprimés.",
    set_err_delete_all: "La suppression a échoué.",
    set_privacy: "Confidentialité (RGPD)",
    set_privacy_sub: "Tes données, tes droits.",
    set_account: "Compte",
    set_account_note: "Tes souvenirs te suivent sur tous tes appareils.",
    set_logout: "Se déconnecter",
    onb_title: "Faisons connaissance",
    onb_sub: "Juste l'essentiel pour commencer.",
    onb_firstname: "Ton prénom",
    onb_firstname_ph: "Prénom",
    onb_consent: "J'ai lu et j'accepte la ",
    onb_consent_link: "politique de confidentialité",
    onb_optional: "Facultatif",
    onb_birthyear: "Année de naissance",
    onb_birthyear_ph: "ex. 1985",
    onb_contact: "Eric peut me contacter pour un retour à la fin du test",
    onb_cta: "Commencer",
    onb_err: "Indique ton prénom et accepte la politique de confidentialité.",
    onb_save_err: "L'enregistrement a échoué. Réessaie.",
    imp_title: "Aide-nous à améliorer rememor",
    imp_header: "Facultatif. Ces réponses nous aident à améliorer rememor — tes souvenirs, eux, restent à toi.",
    imp_firstname: "Prénom",
    imp_birthyear: "Année de naissance",
    imp_keeps: "Où gardes-tu tes souvenirs aujourd'hui ?",
    imp_keep_journal: "Journal",
    imp_keep_photos: "Photos",
    imp_keep_notes: "Notes",
    imp_keep_social: "Réseaux sociaux",
    imp_keep_none: "Rien",
    imp_wants: "Qu'aimerais-tu capturer ?",
    imp_wants_ph: "En quelques mots…",
    imp_heard: "Comment as-tu connu rememor ?",
    imp_heard_friend: "Un ami",
    imp_heard_eric: "Eric directement",
    imp_heard_other: "Autre",
    imp_tech: "À l'aise avec la technologie ?",
    imp_tech_low: "Pas trop",
    imp_tech_mid: "Moyen",
    imp_tech_high: "Très à l'aise",
    imp_contact: "Eric peut me contacter pour un retour",
    imp_saved: "Enregistré ✓",
    set_soon: "Bientôt",
    set_soon_pill: "bientôt",
    set_sound_vib: "Son & vibration",
    set_embellish: "Embellir mes captures",
    set_embellish_sub: "rememor met tes souvenirs au propre, sans jamais changer le fond. L'original reste toujours accessible.",
    set_face_id: "Verrou Face ID",
    set_reminders: "Rappels matin / soir",
    set_sensitive: "Souvenirs sensibles",
    set_reset_zero: "Repartir de zéro",
    set_feedback: "Donner un avis",
    set_footer: "rememor · brique 1",

    instr_1_title: "Parle",
    instr_1_body:
      "Maintiens le bouton micro pour parler. Relâche : c'est attrapé — le texte tombe dans le champ, tu peux le corriger.",
    instr_2_title: "Verrouille un long récit",
    instr_2_body:
      "Pour une longue histoire, glisse vers le haut pendant que tu parles pour verrouiller l'enregistrement (mains libres).",
    instr_3_title: "Ou écris",
    instr_3_body:
      "Tu préfères écrire ? Tape dans le champ, puis appuie sur la flèche pour envoyer.",

    priv_1_title: "Ce qu'on stocke",
    priv_1_body:
      "Uniquement ce que tu captures : le texte de tes souvenirs, l'audio si tu dictes, et la date. Rien d'autre.",
    priv_2_title: "Où, et comment",
    priv_2_body:
      "Tes données sont hébergées sur Supabase (Postgres), chiffrées au repos. Elles ne sont jamais vendues ni partagées avec des tiers.",
    priv_3_title: "Tes droits",
    priv_3_body:
      "Tu peux à tout moment accéder à tes souvenirs, les exporter, les supprimer, et retirer ton consentement.",
    priv_go_data: "Aller à « Mes données »",
  },

  en: {
    app_loading: "one moment…",
    app_auth_error:
      "Can't connect. Please try again in a moment.",

    login_subtitle: "Enter your email and we'll send you a link to sign in.",
    login_email_placeholder: "you@email.com",
    login_cta: "Send my link",
    login_sent: "Check your inbox — we've sent you a link to sign in.",
    login_other_email: "Use a different email",
    login_error: "Couldn't send. Check your email and try again.",
    login_error_rate: "Too many requests. Please wait a few minutes and try again.",
    login_error_invalid: "Invalid email address. Check it and try again.",
    login_note: "No password. The same link signs you in and creates your account.",
    login_pwd_link: "Sign in with a password",
    login_pwd_password_placeholder: "Password",
    login_pwd_cta: "Sign in",
    login_pwd_error: "Incorrect email or password.",
    login_pwd_hide: "Use the magic link instead",

    cap_settings_aria: "Settings",
    cap_placeholder: "Write, or hold the mic…",
    cap_prompt: "Catch whatever crosses your mind",
    cap_listening: "listening… slide ↑ to lock",
    cap_listening_locked: "listening, speak freely…",
    cap_transcribing: "transcribing…",
    cap_caught: "caught",
    cap_err_mic: "Mic unavailable. Allow microphone access.",
    cap_err_transcribe: "Transcription failed. Try again.",
    cap_err_save: "The memory couldn't be saved.",
    cap_locked: "Locked",
    cap_hands_free: "hands-free",
    cap_finish: "Done",
    cap_send_aria: "Send",
    cap_hold_aria: "Hold to dictate",

    exp_title: "Explore",
    exp_subtitle: "What you've caught.",
    exp_loading: "Loading…",
    exp_err_load: "Couldn't load memories.",
    exp_empty: "Nothing yet. Go capture a memory.",
    exp_audio_no_text: "(audio without text)",
    exp_err_audio: "Audio playback failed.",
    exp_voice_tag: " · 🎙 voice",
    exp_del_title: "Delete this memory?",
    exp_del_text: "Both the text AND the audio will be erased, permanently.",
    exp_cancel: "Cancel",
    exp_delete: "Delete",
    exp_err_delete: "Deletion failed.",
    exp_play_aria: "Play",
    exp_pause_aria: "Pause",
    exp_delete_aria: "Delete this memory",

    set_title: "Settings",
    set_how_title: "How it works",
    set_privacy_title: "Privacy",
    set_back_aria: "Back",
    set_ui_lang: "Interface language",
    set_ui_lang_sub: "The app's language.",
    set_input_lang: "Input language",
    set_input_lang_sub: "For capturing your memories.",
    set_hand: "Dominant hand",
    set_hand_sub: "Puts “Capture” under your thumb.",
    set_left: "Left-handed",
    set_right: "Right-handed",
    set_theme: "Theme",
    set_theme_sub: "The app's mood.",
    set_day: "Day",
    set_night: "Night",
    set_system: "System",
    set_how: "How it works",
    set_how_sub: "The gesture, in 30 seconds.",
    set_data: "My data",
    set_data_sub: "Export or erase your memories.",
    set_export: "Export (JSON)",
    set_delete_data: "Delete my data",
    set_delete_all_text: "This will erase all your memories, permanently. Continue?",
    set_delete_yes: "Yes, erase",
    set_exported: "{n} memory(ies) exported.",
    set_err_export: "Export failed.",
    set_deleted_all: "Your memories have been deleted.",
    set_err_delete_all: "Deletion failed.",
    set_privacy: "Privacy (GDPR)",
    set_privacy_sub: "Your data, your rights.",
    set_account: "Account",
    set_account_note: "Your memories follow you on all your devices.",
    set_logout: "Sign out",
    onb_title: "Let's get to know you",
    onb_sub: "Just the essentials to get started.",
    onb_firstname: "Your first name",
    onb_firstname_ph: "First name",
    onb_consent: "I have read and accept the ",
    onb_consent_link: "privacy policy",
    onb_optional: "Optional",
    onb_birthyear: "Birth year",
    onb_birthyear_ph: "e.g. 1985",
    onb_contact: "Eric may contact me for feedback at the end of the test",
    onb_cta: "Get started",
    onb_err: "Enter your first name and accept the privacy policy.",
    onb_save_err: "Saving failed. Please try again.",
    imp_title: "Help us improve rememor",
    imp_header: "Optional. These answers help us improve rememor — your memories stay yours.",
    imp_firstname: "First name",
    imp_birthyear: "Birth year",
    imp_keeps: "Where do you keep your memories today?",
    imp_keep_journal: "Journal",
    imp_keep_photos: "Photos",
    imp_keep_notes: "Notes",
    imp_keep_social: "Social media",
    imp_keep_none: "Nothing",
    imp_wants: "What would you like to capture?",
    imp_wants_ph: "In a few words…",
    imp_heard: "How did you hear about rememor?",
    imp_heard_friend: "A friend",
    imp_heard_eric: "Eric directly",
    imp_heard_other: "Other",
    imp_tech: "Comfortable with technology?",
    imp_tech_low: "Not really",
    imp_tech_mid: "Somewhat",
    imp_tech_high: "Very",
    imp_contact: "Eric may contact me for feedback",
    imp_saved: "Saved ✓",
    set_soon: "Coming soon",
    set_soon_pill: "soon",
    set_sound_vib: "Sound & vibration",
    set_embellish: "Embellish my captures",
    set_embellish_sub: "rememor tidies up your memories without ever changing the substance. The original always stays accessible.",
    set_face_id: "Face ID lock",
    set_reminders: "Morning / evening reminders",
    set_sensitive: "Sensitive memories",
    set_reset_zero: "Start over",
    set_feedback: "Give feedback",
    set_footer: "rememor · brick 1",

    instr_1_title: "Speak",
    instr_1_body:
      "Hold the mic button to speak. Release: it's caught — the text drops into the field, you can edit it.",
    instr_2_title: "Lock a long story",
    instr_2_body:
      "For a long story, slide up while speaking to lock the recording (hands-free).",
    instr_3_title: "Or write",
    instr_3_body:
      "Prefer writing? Type in the field, then tap the arrow to send.",

    priv_1_title: "What we store",
    priv_1_body:
      "Only what you capture: the text of your memories, the audio if you dictate, and the date. Nothing else.",
    priv_2_title: "Where, and how",
    priv_2_body:
      "Your data is hosted on Supabase (Postgres), encrypted at rest. It is never sold or shared with third parties.",
    priv_3_title: "Your rights",
    priv_3_body:
      "At any time you can access your memories, export them, delete them, and withdraw your consent.",
    priv_go_data: "Go to “My data”",
  },

  ru: {
    app_loading: "одну секунду…",
    app_auth_error:
      "Не удаётся подключиться. Повторите попытку через мгновение.",

    login_subtitle: "Введите e-mail — мы отправим ссылку для входа.",
    login_email_placeholder: "ваш@email.com",
    login_cta: "Получить ссылку",
    login_sent: "Проверьте почту — мы отправили ссылку для входа.",
    login_other_email: "Использовать другой адрес",
    login_error: "Не удалось отправить. Проверьте e-mail и попробуйте снова.",
    login_error_rate: "Слишком много запросов. Подождите несколько минут и попробуйте снова.",
    login_error_invalid: "Неверный адрес e-mail. Проверьте и попробуйте снова.",
    login_note: "Без пароля. Одна ссылка для входа и создания аккаунта.",
    login_pwd_link: "Войти по паролю",
    login_pwd_password_placeholder: "Пароль",
    login_pwd_cta: "Войти",
    login_pwd_error: "Неверный e-mail или пароль.",
    login_pwd_hide: "Использовать волшебную ссылку",

    cap_settings_aria: "Настройки",
    cap_placeholder: "Пишите или удерживайте микрофон…",
    cap_prompt: "Поймай то, что приходит в голову",
    cap_listening: "слушаю… проведите ↑ чтобы зафиксировать",
    cap_listening_locked: "слушаю, говорите свободно…",
    cap_transcribing: "расшифровываю…",
    cap_caught: "поймано",
    cap_err_mic: "Микрофон недоступен. Разрешите доступ к микрофону.",
    cap_err_transcribe: "Не удалось расшифровать. Попробуйте ещё раз.",
    cap_err_save: "Не удалось сохранить воспоминание.",
    cap_locked: "Зафиксировано",
    cap_hands_free: "свободные руки",
    cap_finish: "Готово",
    cap_send_aria: "Отправить",
    cap_hold_aria: "Удерживайте для диктовки",

    exp_title: "Обзор",
    exp_subtitle: "То, что вы поймали.",
    exp_loading: "Загрузка…",
    exp_err_load: "Не удалось загрузить воспоминания.",
    exp_empty: "Пока ничего. Запишите воспоминание.",
    exp_audio_no_text: "(аудио без текста)",
    exp_err_audio: "Не удалось воспроизвести аудио.",
    exp_voice_tag: " · 🎙 голос",
    exp_del_title: "Удалить это воспоминание?",
    exp_del_text: "Текст И аудио будут удалены безвозвратно.",
    exp_cancel: "Отмена",
    exp_delete: "Удалить",
    exp_err_delete: "Не удалось удалить.",
    exp_play_aria: "Слушать",
    exp_pause_aria: "Пауза",
    exp_delete_aria: "Удалить это воспоминание",

    set_title: "Настройки",
    set_how_title: "Как это работает",
    set_privacy_title: "Конфиденциальность",
    set_back_aria: "Назад",
    set_ui_lang: "Язык интерфейса",
    set_ui_lang_sub: "Язык приложения.",
    set_input_lang: "Язык ввода",
    set_input_lang_sub: "Для записи воспоминаний.",
    set_hand: "Ведущая рука",
    set_hand_sub: "Помещает «Запись» под большой палец.",
    set_left: "Левша",
    set_right: "Правша",
    set_theme: "Тема",
    set_theme_sub: "Настроение приложения.",
    set_day: "День",
    set_night: "Ночь",
    set_system: "Система",
    set_how: "Как это работает",
    set_how_sub: "Жест за 30 секунд.",
    set_data: "Мои данные",
    set_data_sub: "Экспорт или удаление воспоминаний.",
    set_export: "Экспорт (JSON)",
    set_delete_data: "Удалить мои данные",
    set_delete_all_text: "Это безвозвратно удалит все ваши воспоминания. Продолжить?",
    set_delete_yes: "Да, удалить",
    set_exported: "Экспортировано воспоминаний: {n}.",
    set_err_export: "Не удалось экспортировать.",
    set_deleted_all: "Ваши воспоминания удалены.",
    set_err_delete_all: "Не удалось удалить.",
    set_privacy: "Конфиденциальность (GDPR)",
    set_privacy_sub: "Ваши данные, ваши права.",
    set_account: "Аккаунт",
    set_account_note: "Ваши воспоминания доступны на всех устройствах.",
    set_logout: "Выйти",
    onb_title: "Давайте познакомимся",
    onb_sub: "Только самое необходимое для начала.",
    onb_firstname: "Ваше имя",
    onb_firstname_ph: "Имя",
    onb_consent: "Я прочитал(а) и принимаю ",
    onb_consent_link: "политику конфиденциальности",
    onb_optional: "Необязательно",
    onb_birthyear: "Год рождения",
    onb_birthyear_ph: "напр. 1985",
    onb_contact: "Eric может связаться со мной для отзыва в конце теста",
    onb_cta: "Начать",
    onb_err: "Укажите имя и примите политику конфиденциальности.",
    onb_save_err: "Не удалось сохранить. Попробуйте снова.",
    imp_title: "Помогите улучшить rememor",
    imp_header: "Необязательно. Эти ответы помогают улучшить rememor — ваши воспоминания остаются вашими.",
    imp_firstname: "Имя",
    imp_birthyear: "Год рождения",
    imp_keeps: "Где вы храните воспоминания сейчас?",
    imp_keep_journal: "Дневник",
    imp_keep_photos: "Фото",
    imp_keep_notes: "Заметки",
    imp_keep_social: "Соцсети",
    imp_keep_none: "Нигде",
    imp_wants: "Что бы вы хотели сохранять?",
    imp_wants_ph: "В нескольких словах…",
    imp_heard: "Как вы узнали о rememor?",
    imp_heard_friend: "От друга",
    imp_heard_eric: "Напрямую от Eric",
    imp_heard_other: "Другое",
    imp_tech: "Комфортно с технологиями?",
    imp_tech_low: "Не очень",
    imp_tech_mid: "Средне",
    imp_tech_high: "Очень",
    imp_contact: "Eric может связаться со мной для отзыва",
    imp_saved: "Сохранено ✓",
    set_soon: "Скоро",
    set_soon_pill: "скоро",
    set_sound_vib: "Звук и вибрация",
    set_embellish: "Облагородить мои записи",
    set_embellish_sub: "rememor приводит ваши воспоминания в порядок, не меняя сути. Оригинал всегда доступен.",
    set_face_id: "Блокировка Face ID",
    set_reminders: "Утренние / вечерние напоминания",
    set_sensitive: "Чувствительные воспоминания",
    set_reset_zero: "Начать заново",
    set_feedback: "Оставить отзыв",
    set_footer: "rememor · этап 1",

    instr_1_title: "Говорите",
    instr_1_body:
      "Удерживайте кнопку микрофона, чтобы говорить. Отпустите — поймано: текст появится в поле, его можно отредактировать.",
    instr_2_title: "Зафиксируйте длинный рассказ",
    instr_2_body:
      "Для длинного рассказа проведите вверх во время речи, чтобы зафиксировать запись (свободные руки).",
    instr_3_title: "Или пишите",
    instr_3_body:
      "Предпочитаете писать? Введите текст в поле, затем нажмите стрелку, чтобы отправить.",

    priv_1_title: "Что мы храним",
    priv_1_body:
      "Только то, что вы записываете: текст воспоминаний, аудио при диктовке и дату. Ничего больше.",
    priv_2_title: "Где и как",
    priv_2_body:
      "Ваши данные размещены в Supabase (Postgres), зашифрованы в покое. Они никогда не продаются и не передаются третьим лицам.",
    priv_3_title: "Ваши права",
    priv_3_body:
      "В любой момент вы можете получить доступ к воспоминаниям, экспортировать их, удалить и отозвать своё согласие.",
    priv_go_data: "Перейти к «Мои данные»",
  },
};

// Hook : renvoie t(key) et se met à jour quand la langue change.
export function useT() {
  const [lang, setLang] = useState(getSettings().uiLang || "fr");
  useEffect(() => {
    const handler = () => setLang(getSettings().uiLang || "fr");
    window.addEventListener("lang-change", handler);
    return () => window.removeEventListener("lang-change", handler);
  }, []);
  const t = (key) => {
    const table = translations[lang] || translations.fr;
    return table[key] != null ? table[key] : translations.fr[key] != null ? translations.fr[key] : key;
  };
  return { t, lang };
}
